import { render, staticRenderFns } from "./InvoiceSuper.vue?vue&type=template&id=19d83f9b&scoped=true"
import script from "./InvoiceSuper.vue?vue&type=script&lang=js"
export * from "./InvoiceSuper.vue?vue&type=script&lang=js"
import style0 from "./InvoiceSuper.vue?vue&type=style&index=0&id=19d83f9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d83f9b",
  null
  
)

export default component.exports